import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from './pilot-ui/dialog';
import Button from './ui/Button';

/** Served from public/ when the drawing is first opened. */
export const ASSY_DRAWING_SRC = '/clip-assy-dwg-v1-production.png';

interface AssyDrawingPaneProps {
  open: boolean;
  onClose: () => void;
}

const AssyDrawingPane: React.FC<AssyDrawingPaneProps> = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
    {open && <div onClick={(event) => event.stopPropagation()} onPointerDown={(event) => event.stopPropagation()}><Drawing onClose={onClose} /></div>}
  </Dialog>
);

// Mounting the drawing only while open resets zoom and defers the image request.
const Drawing: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [zoomed, setZoomed] = useState(false);
  return (
    <DialogContent
      customWidth
      forceBackdrop
      showCloseButton={false}
      className="flex max-h-[95vh] w-full max-w-[calc(100%-2rem)] flex-col gap-0 overflow-hidden p-0 sm:max-w-6xl"
      aria-describedby="assy-drawing-help"
    >
      <div className="flex items-center justify-between border-b p-4">
        <div>
          <DialogTitle className="text-xl font-semibold">Clip assembly drawing — V-1 Production</DialogTitle>
          <p id="assy-drawing-help" className="text-xs text-muted-foreground">Activate the drawing to zoom in or return to fit.</p>
        </div>
        <Button variant="icon" onClick={onClose} aria-label="Close" title="Close the assembly drawing and return to the device editor">
          &times;
        </Button>
      </div>
      <div className="min-h-0 flex-1 overflow-auto p-4">
        <Button
          variant="icon"
          onClick={() => setZoomed((current) => !current)}
          title={zoomed ? 'Fit the assembly drawing to the dialog' : 'Zoom the assembly drawing to actual size'}
          aria-label={zoomed ? 'Fit assembly drawing' : 'Zoom assembly drawing'}
          className={zoomed ? 'h-auto max-w-none p-0' : 'mx-auto h-auto w-full p-0'}
        >
          <img
            src={ASSY_DRAWING_SRC}
            alt="FluxHive Clip assembly drawing, V-1 Production"
            className={zoomed ? 'block max-w-none' : 'mx-auto block h-auto max-w-full'}
          />
        </Button>
      </div>
    </DialogContent>
  );
};

export default AssyDrawingPane;
